import FlashIcon from '../components/FlashIcon'

export const levels = [
    {
        level: 'beginner',
        icon: <FlashIcon />
    },
    {
        level: 'intermediate',
        icon: <><FlashIcon /><FlashIcon /></>
    },
    {
        level: 'expert',
        icon: <><FlashIcon /><FlashIcon /><FlashIcon /></>
    },
    
]